module.exports = __webpack_public_path__ + "img/icon-zap-off.ded16bf8.svg";